import { shapes } from '@joint/plus';
import React, { ChangeEvent, ReactElement, useCallback, useEffect, useState } from 'react';

import Input from '../Input/Input';
import SmartAutocomplete from '../Input/SmartAutocomplete/SmartAutocomplete';
import { useBaseInspector } from './useBaseInspector';

import ReactQuill from 'react-quill';
import * as ChatbotFlowService from "../../../../../../../../services/2talk/chatbot-flow.service";
import HelperCustomField from '../../HelperCustomField/HelperCustomField';
import { Switch } from '@mui/material';

interface Props {
    cell: shapes.app.Flow;
    chatbotId: string;
    chatbotFlowId: string;
}

const cellProps = {
    label: ['attrs', 'label', 'text'],
    description: ['attrs', 'description', 'text'],
    icon: ['attrs', 'icon', 'xlinkHref'],
    portLabel: ['attrs', 'portLabel', 'text'],
    flowId: ['attrs', 'flowId', 'id'],
    isTextRich: ['attrs', 'isTextRich', 'isTextRich'],
};

const FlowInspector = (props: Props): ReactElement => {

    const { cell, chatbotFlowId } = props;

    const [flowsOptions, setFlowsOptions] = useState([]);

    const [label, setLabel] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [flowId, setFlowId] = useState(null);
    const [isTextRich, setIsTextRich] = useState<boolean>(false);

    const assignFormFields = useCallback((): void => {
        setLabel(cell.prop(cellProps.label));
        setDescription(cell.prop(cellProps.description));
        setFlowId(cell.prop(cellProps.flowId));
        setIsTextRich(cell.prop(cellProps.isTextRich));
    }, [cell]);

    const changeCellProp = useBaseInspector({ cell, assignFormFields });

    const fetchFlows = async () => {
        const flows = await ChatbotFlowService.getList(props.chatbotId, props.chatbotFlowId);
        setFlowsOptions(flows?.data ?? []);
    }

    useEffect(() => {
        fetchFlows();
    }, [])

    return (
        <>

            <label>Label
                <Input type="text"
                       placeholder="Enter label"
                       value={label}
                       disabled={true}
                />
            </label>

            <div style={{ marginBottom: '8px', marginTop: '8px'}}>
                <Switch
                    value={isTextRich}
                    checked={isTextRich}
                    onChange={(e:any) => changeCellProp(cellProps.isTextRich, e?.target?.checked)}     
                />
                <label>É um texto rico?</label>
            </div>

            {
                isTextRich
                ? (
                    <label>Descrição
                        <div style={{ resize: "vertical", overflow: "auto", height: "250px", marginBottom: "24px", border: "1px solid #ccc" }}>
                            <ReactQuill
                                style={{ height: '100%' }}
                                name="description"
                                fullWidth
                                variant="outlined"
                                id="descriprion"
                                value={description}
                                onChange={(value: any) => changeCellProp(cellProps.description, value)}
                            />
                        </div>
                    </label>
                )
                : (
                    <label>Descrição
                        <Input 
                            type="text"
                            placeholder="Enter description"
                            value={description}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => changeCellProp(cellProps.description, e.target.value)}
                        />
                    </label>
                )
            }

            <HelperCustomField
                isRichText={isTextRich}
                description={description}
                param1={cellProps.description}
                onChangeDescription={changeCellProp}
                chatbotFlowId={chatbotFlowId}
                hideChatTab
            />

            <label>Fluxos
                <SmartAutocomplete 
                    value={flowId}
                    onChange={(e) => changeCellProp(cellProps.flowId, e.target.value)}
                    options={flowsOptions}
                />
            </label>
        </>
    );
};

export default FlowInspector;
